module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesCreative@2x.9579b6d.jpg";